import React, { Component } from "react"
import { Button, Table, Image } from "react-bootstrap"
import { ServiceDataModel } from "../OrderModels"
import { FaTimes } from "react-icons/fa"
import ConfirmationModal from "../../ConfirmationModal"
import dotImage from "../../../assets/images/dot-img.png"
import shoppingCarImage from "../../../assets/images/shopping-cart.png"

export interface OrderedServicesProps {
  services: ServiceDataModel[],
  canConfirm: boolean,
  canRemove: boolean,
  onRemoveService: (id: number) => void,
  onConfirm: () => void
}

interface OrderedServicesState {
  showRemoveConfirmation: boolean
  idToRemove?: number
}

export default class OrderedServices extends Component<OrderedServicesProps> {
  state: OrderedServicesState = { showRemoveConfirmation: false }

  closeRemoveConfirmation = () => this.setState({ showRemoveConfirmation: false, idToRemove: undefined })
  performRemove = () => {
    if (!this.props.canRemove) {
      return
    }
    this.closeRemoveConfirmation()
    this.props.onRemoveService(this.state.idToRemove || 0)
  }

  render() {
    const { services, canConfirm, onConfirm } = this.props
    if (services.length === 0) {
      return <></>
    }
    return (
      <div>
        <div className="font-weight-bold">CART&nbsp;<Image className="ml-auto" src={shoppingCarImage}  /></div>
        <Table className="table-sm dark" responsive>
          <thead>
            <tr>
              <th>SERVICE TYPE</th>
              <th></th>
              <th>ACCOUNT</th>
              <th>TEST TO BE PERFORMED</th>
              {this.props.canRemove && <th>REMOVE</th>}
            </tr>
          </thead>
          <tbody>
            {services.map((service, index) =>
              <tr key={service.id}>
                <td className="justify-content-between">
                  <span>{service.serviceTypeCode}</span>
                </td>
                <td><Image className="ml-auto" src={dotImage} hidden={service.isDOT !== true} /></td>
                <td>{service.labAccount}</td>
                <td>{service.testToPerform}</td>
                {this.props.canRemove && <td >
                  <Button size="sm" variant="outline-dark" className="btn-icon-link py-0" onClick={() => this.setState({ showRemoveConfirmation: true, idToRemove: service.id })}><FaTimes /></Button>
                </td>}
              </tr>)}
          </tbody>
        </Table>
        <Button size="sm" disabled={!canConfirm} onClick={onConfirm} className="float-right">CONFIRM</Button>
        <div>Count:&nbsp;{services.length}</div>
        <ConfirmationModal show={this.state.showRemoveConfirmation}
          title="CONFIRM REMOVE"
          textTitle="Are you sure you want to remove selected service?"
          text="Selected service will be removed permanently."
          onConfirm={this.performRemove}
          onHide={this.closeRemoveConfirmation} />
      </div>
    )
  }
}
